import { useCallback, useMemo } from 'react';

interface Permission {
    permissionId: string;
}

export function usePermission(permissions?: Permission[]) {
    const hasPermission = useCallback(
        (ids: string[]) => permissions?.some((p) => ids.includes(p.permissionId)),
        [permissions]
    );

    const checkPermission = useMemo(() => (id: string) => hasPermission([id]), [hasPermission]);

    return { hasPermission, checkPermission };
}
